module.exports = __webpack_public_path__ + "static/media/qiwi.20ce4939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qiwi.png
// module id = 310
// module chunks = 0